import { render, staticRenderFns } from "./style.vue?vue&type=template&id=63183a17&scoped=true&"
import script from "./style.vue?vue&type=script&lang=js&"
export * from "./style.vue?vue&type=script&lang=js&"
import style0 from "./style.vue?vue&type=style&index=0&id=63183a17&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63183a17",
  null
  
)

export default component.exports